import axios from 'axios';
import { RouteConstants } from "../../components/route/services/RouteConstants"
import auth from "../auth/AuthProvider";

class Api {
    constructor() {
        let service = axios.create({});
        service.interceptors.response.use(this.handleSuccess, this.handleError);
        this.service = service;
        this.showErrorModal = null;
    }

    initErrorModal = (showErrorModal) => {
        this.showErrorModal = showErrorModal;
    };

    handleSuccess = (response) => {
        return response;
    };

    handleError = (error) => {
        if (error.response && error.response.status === 401) {
            this.redirectTo(document, RouteConstants.LOGIN);
            return;
        }
        if (error.response && error.response.status === 403) {
            // something is going horribly wrong and the user is trying to update a different user's info
            this.redirectTo(document, RouteConstants.LOGOUT);
            return;
        }
        return Promise.reject(error);
    };

    redirectTo = (document, path) => {
        document.location = path
    };

    getRequestHeaders() {
        if (auth.isAuthenticated()) {
            return { Authorization: 'Bearer ' + auth.getAccessToken() };
        }

        return {};
    }

    get(path) {
        return this.service.request({
            method: 'GET',
            headers: this.getRequestHeaders(),
            url: path,
            responseType: 'json'
        });
    }

    put(path, payload) {
        return this.service.request({
            method: 'PUT',
            headers: this.getRequestHeaders(),
            url: path,
            responseType: 'json',
            data: payload
        });
    }

    post(path, payload) {
        return this.service.request({
            method: 'POST',
            headers: this.getRequestHeaders(),
            url: path,
            responseType: 'json',
            data: payload
        });
    }

    delete(path) {
        return this.service.request({
            method: 'DELETE',
            headers: this.getRequestHeaders(),
            url: path,
            responseType: 'json'
        });
    }

}

const api = new Api();
export default api;